import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 pt-24 pb-2">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap max-w-7xl mx-auto">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors">
            <i className="ri-home-4-line"></i>
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}